module.exports = __webpack_public_path__ + "static/img/admin_dnsd.2d0b319.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin_dnsd.png
// module id = NQat
// module chunks = 1